import { makeStyles } from '@mui/styles';
import qs from 'query-string';
import React from 'react';
import { useDispatch } from 'react-redux';

import { handleImportModalOpen } from '../../../actions/BulkImportActions';
import Link from '../../../components/Link';
import { NOTIFICATION_BULK_UPLOAD_ORIGINS } from '../../../constants/NotificationConstants';
import { WORKFLOW_MASTER_SETUP_PAGE } from '../../../constants/Urls';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { parseNotificationUrl } from '../../../utils/importUtils';

const useStyles = makeStyles({
  linkContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 10,
  },
  link: {
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: '#297dfd',
  },
});

export const NotificationLink = ({
  notificationUrl,
  handleNotificationsClose,
  importKey,
  origin,
}) => {
  const translateString = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { pathname, search } = parseNotificationUrl(notificationUrl);
  const { entityName } = qs.parse(search) || {};
  const isBulkUploadNotification = NOTIFICATION_BULK_UPLOAD_ORIGINS.includes(origin) && importKey;
  const isWorkflowMasterSetup = pathname === WORKFLOW_MASTER_SETUP_PAGE;

  const notificationLinkTitle = isBulkUploadNotification ? 'Go to Bulk Import' : 'Go to the page';

  const handleLinkClick = () => {
    if (isBulkUploadNotification && entityName) {
      dispatch(handleImportModalOpen(entityName, importKey, isWorkflowMasterSetup));
    }
    handleNotificationsClose();
  };

  return (
    <div className={classes.linkContainer}>
      <Link
        className={classes.link}
        to={{ pathname, search }}
        target="_self"
        onClick={handleLinkClick}
      >
        {translateString(notificationLinkTitle)}
      </Link>
    </div>
  );
};
